var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9915378c01b382be7effa75910bb7c704996dbf2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["legacy@interpals"]={id:"9915378c01b382be7effa75910bb7c704996dbf2"};
      